import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme, alpha } from '@mui/material/styles';
import colors from 'global/styles/colors';
import { get, set } from 'global/lib/lodash';
import isLoggedIn from 'global/utils/isLoggedIn';
import { red, blue } from '@mui/material/colors';
import { useView } from 'global/hooks/useView';
import { mergeDeep } from '../../utils';

const gray = {
  main: colors.grey,
  light: alpha(colors.grey, 0.5),
  dark: alpha(colors.grey, 0.9),
  contrastText: colors.white,
}

export const THEMEDEFAULTS = {
  palette: {
    primary: red,
    secondary: blue,
    contrastThreshold: 3,
    tonalOffset: 0.2,
    gray,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1040,
      xl: 1640,

      sidebar: 300,
      content: 768,
      ad: 300,
      container: 1400,
    },
  },
  colors: {
    ...colors,
  },
  overrides: {
    MuiButton: {
      root: {
        lineHeight: 1.5,
      },
    },
    MuiAppBar: {
      root: {
        zIndex: 900,
      },
    },
    MuiSvgIcon: {
      root: {
        transition: 'none',
      },
    },
  },
};

const newProps = {
  components: {
    MuiCheckbox: {
      defaultProps: {
        color: 'secondary',
      }
    },
    MuiRadio: {
      defaultProps: {
        color: 'secondary',
      }
    },
  },
}

const theme = createTheme(adaptV4Theme({
  ...THEMEDEFAULTS,
}));

export default (props) => {
  const [currentTheme, setCurrentTheme] = useState(theme);
  const viewStyle = useSelector((state) => get(state, 'view.style'));
  const auth = useSelector((state) => state.auth);
  const loggedIn = isLoggedIn(auth);
  const { isMobile } = useView();

  const adaptTheme = vals => {
    set(vals, 'isMobile', isMobile);
    const adapted = adaptV4Theme({ ...vals });
    return mergeDeep(adapted, newProps);
  }

  useEffect(() => {
    if (!loggedIn) {
      setCurrentTheme(createTheme(adaptTheme({ ...THEMEDEFAULTS })));
    }
  }, [loggedIn]);

  useEffect(() => {
    const newTheme = { ...THEMEDEFAULTS };
    if (get(viewStyle, 'palette.primary.main') && get(viewStyle, 'palette.secondary.main')) {
      delete newTheme.palette.primary;
      delete newTheme.palette.secondary;
      set(viewStyle, 'palette.gray', gray);
      setCurrentTheme(createTheme(adaptTheme({ ...newTheme, ...viewStyle })));
    }
  }, [viewStyle]);

  useEffect(() => {
    setCurrentTheme(createTheme(adaptTheme(currentTheme)));
  }, [isMobile]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={currentTheme}>{props.children}</ThemeProvider>
    </StyledEngineProvider>
  );
};
